<template>
  <StMobileTabs
    v-model="activeTabId"
    :tab-items="itemsForMobileTabs"
    size="m"
  />
</template>

<script setup lang="ts">
import StMobileTabs from '@st/ui/components/StMobileTabs/StMobileTabs.vue'
import type { MobileTab } from '@st/ui/components/StMobileTabs/types'
import type { SportTab } from './types'
import { getEventBackground } from '../../helpers/getEventBackground'

interface Props {
  items: SportTab[]
  selectedTab: string | number
  isLive?: boolean
  allCounter?: number
  isCybersport?: boolean
}

const { t } = useI18n()

const props = defineProps<Props>()

const { liveEventsMap } = useSportMenu()
function getTournametLiveCount(entityId: string) {
  return liveEventsMap.value[entityId]?.size ?? 0
}

const allEventTab = computed(() =>
  props.isCybersport
    ? {
        id: 'all',
        label: t('events.all'),
        icon: 'cybersport' as const,
        counter: props.allCounter ?? 0,
        actionColor: '#38003D',
      }
    : {
        id: 'all',
        label: t('events.all'),
        icon: 'all-sports' as const,
        counter: props.allCounter ?? 0,
        actionColor: '#002332',
      },
)

const itemsForMobileTabs = computed<MobileTab[]>(() => [
  allEventTab.value,
  ...props.items.map(({ id, title, icon, numberId }) => ({
    id,
    label: title,
    icon,
    counter: props.isLive ? getTournametLiveCount(id) : 0,
    actionColor: getEventBackground(numberId ?? 0).hashColor,
  })),
])
const emit = defineEmits(['select'])

const activeTabId = ref(props.selectedTab ?? 'all')

watch(
  () => activeTabId.value,
  (newValue) => {
    if (newValue) {
      const currentTab = itemsForMobileTabs.value.find(
        ({ id }) => id === newValue,
      )
      if (!currentTab) return

      if (currentTab.id === 'all') {
        emit('select', [])
      } else emit('select', [currentTab])
    }
  },
)
</script>
